export default __webpack_public_path__ + "static/media/gallery-wip-emitter_08.75e5d652.jpg";